import React, { Component, createRef } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { Spin } from "antd";
import styles from './wave.less';

class Wave extends Component {

    waveformContainer = createRef();

    waveform = undefined;

    state = {
        loading: true,
    };


    loadCurrentWave = (waveUrl) => {
        const encodeWaveUrl = encodeURIComponent(waveUrl).replaceAll("%3A", ":").replaceAll("%2F", "/");
        if (this.props.peakUrl) {
            fetch(this.props.peakUrl)
                .then(res => {
                    res.json().then(result => {
                        this.waveform?.load(encodeWaveUrl, result.data);
                    });
                });
        }
        else {
            this.waveform?.load(encodeWaveUrl);
        }

    }

    initWave = (waveUrl) => {
        if (this.waveformContainer) {
            this.waveform = WaveSurfer.create({
                container: this.waveformContainer.current,
                progressColor: 'black',
                waveColor: 'green',
                backend: 'MediaElement',
                autoCenter: true,
                pixelRatio: 1,
                normalize: true,
                // minPxPerSec: 200,
                audioRate: this.state.waveRate ?? 1,
                scrollParent: true,
                height: 150,
                cursorWidth: 2,
                cursorColor: '#1890ff',
                // fillParent: true,
                hideScrollbar: false,
                loopSelection: false,
                plugins: [],
            });
            this.waveform.once('ready', () => {
                this.setState({
                    loading: false,
                }, () => {
                    this.waveformContainer.current?.addEventListener('click', this.handlePlayWave);
                });
            });

            try {
                if (waveUrl) {
                    this.loadCurrentWave(waveUrl);
                }
            } catch (exception) {
                // eslint-disable-next-line no-console
                console.log('wave load error', exception);
            }

        }
    }

    componentDidMount() {
        console.log(this.props.waveUrl)
        this.initWave(this.props.waveUrl);
    }

    handlePlayWave = () => {
        this.waveform?.play();
    }

    handlePlayOrPauseWave = () => {
        if (this.waveform?.isPlaying()) {
            this.waveform?.pause();
        } else {
            this.waveform?.play();
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.waveUrl !== this.props.waveUrl) {
            if (this.waveform) {
                try {
                    if (nextProps.waveUrl) {
                        this.loadCurrentWave(nextProps.waveUrl);
                    }
                } catch (exception) {
                    // eslint-disable-next-line no-console
                    console.log('load error', exception);
                }
            }
        }
    }


    render() {
        return (
            <Spin spinning={this.state.loading} >
                <div className={styles.waveformContainer} ref={this.waveformContainer} id={this.props.id} key={this.props.id} />
            </Spin>
        );
    }

}

export default Wave;
